<template>
  <modal title="Detail" size="xl" @close="$emit('close')">
    <template #content>
      <loadArea v-if="data == null"></loadArea>
      <template v-if="data != null">
        <div class="row m-0">
          <div class="col-6 p-10">
            <ul class="border">
              <template
                v-for="(keys, index) in Object.keys(data.Detail)"
                :key="keys"
              >
                <li v-if="index % 2 == 0">
                  <strong>{{ keys }}:</strong>
                  <a
                    target="_blank"
                    :href="data.Detail[keys]"
                    v-if="keys == 'ContentFileUrl'"
                  >
                    {{ data.Detail[keys] }}
                  </a>
                  <a
                    target="_blank"
                    :href="
                      'https://reservations.ams3.digitaloceanspaces.com/bodies/' +
                        data.Detail[keys]
                    "
                    v-if="keys == 'ContentFileName'"
                  >
                    {{ data.Detail[keys] }}
                  </a>
                  <template
                    v-if="keys != 'ContentFileUrl' && keys != 'ContentFileName'"
                  >
                    <template v-if="keys != 'ToAddress'">
                      {{ data.Detail[keys] }}
                    </template>
                    <template
                      v-if="keys == 'ToAddress' && data.Detail[keys] != null"
                    >
                      <span
                        class="pointer"
                        @click="$root.clipboardCopy(item)"
                        v-for="item in data.Detail[keys].split(';')"
                        :key="item"
                      >
                        {{ item }} <br />
                      </span>
                    </template>
                  </template>
                  <i
                    v-if="keys != 'ToAddress'"
                    @click="$root.clipboardCopy(data.Detail[keys])"
                    class="fas fa-copy"
                  ></i>
                </li>
              </template>
            </ul>
          </div>
          <div class="col-6 p-10">
            <ul class="border">
              <template
                v-for="(keys, index) in Object.keys(data.Detail)"
                :key="keys"
              >
                <li v-if="index % 2 == 1">
                  <strong>{{ keys }}:</strong>
                  <a
                    target="_blank"
                    :href="data.Detail[keys]"
                    v-if="keys == 'ContentFileUrl'"
                  >
                    {{ data.Detail[keys] }}
                  </a>
                  <a
                    target="_blank"
                    :href="data.Detail[keys]"
                    v-if="keys == 'ContentFileName'"
                  >
                    {{ data.Detail[keys] }}
                  </a>
                  <template
                    v-if="keys != 'ContentFileUrl' && keys != 'ContentFileName'"
                  >
                    {{ data.Detail[keys] }}
                  </template>
                  <i
                    @click="$root.clipboardCopy(data.Detail[keys])"
                    class="fas fa-copy"
                  ></i>
                </li>
              </template>
            </ul>
          </div>
        </div>
        <div
          class="row attachments border-top"
          v-if="data.Attachments.length > 0"
        >
          <div
            class="col-auto p-10"
            v-for="item in data.Attachments"
            :key="item.FileName"
          >
            <a
              target="_blank"
              :href="
                'https://reservations.ams3.digitaloceanspaces.com/attachments/' +
                  item.BucketFileName
              "
              class="badge bg-secondary"
              >{{ item.BucketFileName }}</a
            >
          </div>
        </div>
        <div
          class="border-top mailContent"
          v-if="data.Detail.ContentFileName != null"
        >
          <button
            class="btn btn-info btn-xs waves-effect waves-light m-l-5"
            type="button"
            @click="$root.clipboardCopy(contentFileName)"
          >
            <span>Copy</span>
          </button>
          <div class="p-10" v-if="contentFileName != null">
            <small class="p-b-10 block">ContentFileName</small>
            <pre class="m-0">{{ contentFileName }}</pre>
          </div>
          <loadArea v-if="contentFileName == null"></loadArea>
        </div>
      </template>
    </template>
  </modal>
</template>

<script>
import axios from "axios";
export default {
  name: "show",
  props: {
    id: String,
  },
  data() {
    return {
      addCurrenciesOpen: false,
      model: {
        Active: false,
        CurrencyCode: "",
        DurationBased: false,
        Id: null,
        IncreementDayCount: null,
        IsPortal: false,
        Logo: null,
        MainOperatorId: null,
        MaxDayCount: null,
        MaxHotelCount: null,
        Name: "",
        OutputPort: null,
        RegionBased: false,
        ResponseItemCount: null,
        ScanModel: null,
        ShortName: "",
        UsingSameHotelsWithMainOperator: false,
      },
      data: null,
      process: false,
      rescanShow: false,
      contentFileName: null,
    };
  },
  created() {
    this.$appAxiosAdmin
      .get(`KOLAYREZ/Mails/` + this.id)
      .then((response) => {
        this.data = response.data;
        if (this.data.Detail.ContentFileName != null) {
          this.getContentFileName();
        }
      })
      .catch((err) => {
        this.$isError(err);
        this.$emit("close");
      });
  },
  methods: {
    getContentFileName() {
      axios
        .get(
          "https://reservations.ams3.digitaloceanspaces.com/bodies/" +
            this.data.Detail.ContentFileName
        )
        .then((response) => {
          this.contentFileName = response.data;
        });
    },
    setResponse(data) {
      try {
        return JSON.parse(data);
      } catch (error) {
        return data;
      }
    },
  },
};
</script>

<style scoped>
pre {
  box-shadow: none;
}
ul li {
  padding: 5px 30px 5px 10px;
  font-size: 14px;
  word-wrap: break-word;
  position: relative;
}
ul li:nth-child(even) {
  background: #f6f6f6;
}
ul li i {
  position: absolute;
  right: 0;
  top: 0;
  line-height: 30px;
  width: 30px;
  text-align: center;
  cursor: pointer;
}
.attachments {
  margin: 0;
  padding: 8px;
}
.attachments > div {
  padding: 2px;
}
.attachments > div a {
  margin: 0 !important;
  display: block;
}
.mailContent {
  position: relative;
}
.mailContent > button {
  position: absolute;
  right: 10px;
  top: 6px;
}
</style>
